import { MenuButtonGroup } from '@/components/features/SettingMenuButtonGroup';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { FormGroup } from '@/components/element/Form/FormGroup';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useNavState } from '@/providers/NavStateProvider';
import { useLoading } from '@/providers/LoadingProvider';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { toastSuccess } from '@/lib/toast';
import Cookies from 'js-cookie';

export const MoneyForwardConnectNew = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('新規Money Forward接続'), []);
  useEffect(() => setBreadcrumbs([{ label: `外部サービス連携`, path: `/w/${_w_!.identifier}/setting/connect` }]), []);

  const { setShowLoading } = useLoading();
  const { _w_, me } = useCurrentWorkspace();
  const [clientId, setClientId] = useState('');
  const [clientSecret, setClientSecret] = useState('');
  const [redirectUri, setRedirectUri] = useState(
    `${process.env.REACT_APP_SITE_URL}/w/${_w_!.identifier}/setting/connect/mf/callback`
  );
  const [authUrl, setAuthUrl] = useState<string>();

  const uriCopyClick = () => {
    navigator.clipboard.writeText(redirectUri).then((_) => toastSuccess('コピーしました'));
  };

  const connectClick = (e: React.MouseEvent) => {
    if (authUrl) {
    } else {
      e.preventDefault();
    }
  };

  useEffect(() => {
    if (clientId && clientSecret) {
      Cookies.set('mf_client_id', clientId, { sameSite: 'strict' });
      Cookies.set('mf_client_secret', clientSecret, { sameSite: 'strict' });
      const authUrl = `https://api.biz.moneyforward.com/authorize?response_type=code&client_id=${clientId}&scope=mfc/admin/office.read mfc/invoice/data.read mfc/invoice/data.write&redirect_uri=${
        process.env.REACT_APP_SITE_URL
      }/w/${_w_!.identifier}/setting/connect/mf/callback`;
      setAuthUrl(authUrl);
    } else {
      setAuthUrl(undefined);
    }
  }, [clientId, clientSecret]);

  return (
    <WorkspaceLayout>
      <div className="container-fluid py-4">
        <MenuButtonGroup selected={'connect'} />

        <div className="row">
          <div className="col-12 col-lg-9 mx-auto">
            <div className="card mb-4" id="basic-info">
              <div className="card-header d-flex align-items-center">
                <div className="col-md-8">
                  <h5 className="mb-0">新規Money Forward接続</h5>
                </div>
              </div>

              <div className="card-body pt-0">
                <div className="col-md-6">
                  <FormGroup label={'Client ID'} required={true}>
                    <input
                      type="text"
                      className={'form-control'}
                      value={clientId}
                      onChange={(e) => setClientId(e.target.value)}
                    />
                  </FormGroup>
                </div>

                <div className="col-md-12">
                  <FormGroup label={'Client Secret'} required={true}>
                    <input
                      type="text"
                      className={'form-control'}
                      value={clientSecret}
                      onChange={(e) => setClientSecret(e.target.value)}
                    />
                  </FormGroup>
                </div>

                <div className="col-12 col-md-12">
                  <div className="form-group">
                    <label>リダイレクトURI</label>
                    <div className="d-flex align-items-center">
                      <input type="text" className="form-control" disabled={true} value={redirectUri} />
                      <button className="btn btn-icon-only btn-outline-success ms-1" onClick={uriCopyClick}>
                        <i className="fas fa-copy text-success text-sm"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-footer d-flex align-items-center justify-content-end pt-0">
                <Link to={`/w/${_w_!.identifier}/setting/connect`} className="btn btn-outline-secondary me-2">
                  戻る
                </Link>
                <Link
                  to={authUrl || ''}
                  className={`btn bg-gradient-dark btn-icon ${!authUrl && 'disabled'}`}
                  onClick={connectClick}
                >
                  <i className="fas fa-check-circle"></i>連携する
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
